// 1 = primary color (body)
// 2 = secondary color (shade/outline)
// 3 = highlight (white/light)
// 4 = eye color (usually white/black)
// 0 = transparent

export type PixelGrid = number[][];

export const ALIEN_SPRITE_NORMAL: PixelGrid = [
  [0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0],
  [0, 0, 1, 3, 3, 1, 1, 1, 1, 0, 0],
  [0, 1, 3, 1, 1, 1, 1, 1, 1, 1, 0],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 4, 4, 1, 1, 1, 4, 4, 1, 1],
  [1, 1, 4, 4, 1, 1, 1, 4, 4, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [0, 1, 1, 1, 1, 2, 2, 2, 1, 1, 0],
  [0, 0, 1, 1, 2, 2, 2, 2, 1, 0, 0],
  [0, 0, 1, 1, 0, 0, 0, 1, 1, 0, 0],
];

export const ALIEN_SPRITE_SCOUT: PixelGrid = [
  // Smaller, more aerodynamic
  [0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0],
  [0, 0, 0, 1, 3, 3, 1, 1, 0, 0, 0],
  [0, 0, 1, 3, 1, 1, 1, 1, 1, 0, 0],
  [0, 1, 1, 4, 1, 1, 1, 4, 1, 1, 0],
  [1, 1, 1, 4, 1, 1, 1, 4, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [0, 1, 1, 1, 2, 1, 2, 1, 1, 1, 0],
  [0, 0, 1, 2, 0, 1, 0, 2, 1, 0, 0],
  [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0],
  [0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const ALIEN_SPRITE_TANK: PixelGrid = [
  // Bulky, round, reinforced
  [0, 0, 0, 2, 2, 2, 2, 2, 0, 0, 0],
  [0, 0, 2, 1, 1, 1, 1, 1, 2, 0, 0],
  [0, 2, 1, 1, 3, 3, 1, 1, 1, 2, 0],
  [2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2],
  [2, 1, 1, 4, 4, 1, 4, 4, 1, 1, 2],
  [2, 1, 1, 4, 4, 1, 4, 4, 1, 1, 2],
  [2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2],
  [2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2],
  [0, 2, 1, 1, 2, 2, 2, 1, 1, 2, 0],
  [0, 0, 2, 2, 1, 1, 1, 2, 2, 0, 0],
  [0, 0, 0, 2, 2, 2, 2, 2, 0, 0, 0],
];

export const ALIEN_SPRITE_HEALER: PixelGrid = [
  // Cross shape or similar
  [0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0],
  [0, 0, 0, 1, 3, 3, 1, 1, 0, 0, 0],
  [0, 0, 1, 1, 3, 3, 1, 1, 1, 0, 0],
  [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 4, 1, 1, 1, 1, 1, 4, 1, 1],
  [1, 1, 1, 1, 2, 2, 2, 1, 1, 1, 1],
  [0, 1, 1, 1, 2, 2, 2, 1, 1, 1, 0],
  [0, 0, 1, 1, 1, 2, 1, 1, 1, 0, 0],
  [0, 0, 0, 1, 0, 2, 0, 1, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const ALIEN_SPRITE_GUARDIAN: PixelGrid = [
  // Round with shield core
  [0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0],
  [0, 0, 1, 1, 3, 3, 1, 1, 1, 0, 0],
  [0, 1, 1, 1, 3, 3, 1, 1, 1, 1, 0],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 3, 1, 4, 1, 4, 1, 3, 1, 1],
  [1, 1, 1, 1, 4, 1, 4, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [0, 1, 1, 1, 2, 2, 2, 1, 1, 1, 0],
  [0, 0, 1, 1, 2, 1, 2, 1, 1, 0, 0],
  [0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const ALIEN_SPRITE_HOARDER: PixelGrid = [
  // Bag-like
  [0, 0, 0, 0, 2, 2, 2, 0, 0, 0, 0],
  [0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0],
  [0, 0, 1, 1, 1, 1, 1, 1, 1, 0, 0],
  [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0],
  [1, 1, 3, 1, 1, 1, 1, 1, 3, 1, 1],
  [1, 1, 4, 1, 1, 1, 1, 1, 4, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [0, 1, 1, 1, 2, 2, 2, 1, 1, 1, 0],
  [0, 0, 1, 1, 2, 2, 2, 1, 1, 0, 0],
  [0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0],
];

// --- Power-Up Sprites ---

export const POWERUP_SPRITE_POINTS: PixelGrid = [
  // Coin
  [0, 0, 0, 2, 2, 2, 2, 2, 0, 0, 0],
  [0, 0, 2, 1, 1, 1, 1, 1, 2, 0, 0],
  [0, 2, 1, 3, 3, 3, 1, 1, 1, 2, 0],
  [2, 1, 3, 1, 2, 2, 1, 1, 1, 1, 2],
  [2, 1, 1, 2, 1, 1, 2, 1, 1, 1, 2],
  [2, 1, 1, 2, 1, 1, 2, 1, 1, 1, 2],
  [2, 1, 1, 1, 2, 2, 1, 1, 1, 1, 2],
  [2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2],
  [0, 2, 1, 1, 1, 1, 1, 1, 1, 2, 0],
  [0, 0, 2, 1, 1, 1, 1, 1, 2, 0, 0],
  [0, 0, 0, 2, 2, 2, 2, 2, 0, 0, 0],
];

export const POWERUP_SPRITE_DAMAGE: PixelGrid = [
  // Sword/Dagger
  [0, 0, 0, 0, 0, 1, 2, 0, 0, 0, 0],
  [0, 0, 0, 0, 1, 3, 1, 2, 0, 0, 0],
  [0, 0, 0, 1, 3, 1, 1, 1, 2, 0, 0],
  [0, 0, 1, 3, 1, 1, 1, 1, 1, 2, 0],
  [0, 0, 0, 1, 1, 1, 1, 1, 2, 0, 0],
  [0, 0, 0, 0, 1, 1, 1, 2, 0, 0, 0],
  [0, 0, 1, 1, 1, 2, 1, 1, 1, 0, 0],
  [0, 1, 2, 0, 2, 2, 2, 0, 2, 1, 0],
  [0, 0, 0, 0, 4, 2, 4, 0, 0, 0, 0],
  [0, 0, 0, 0, 4, 2, 4, 0, 0, 0, 0],
  [0, 0, 0, 0, 2, 2, 2, 0, 0, 0, 0],
];

export const POWERUP_SPRITE_SPEED: PixelGrid = [
  // Lightning Bolt
  [0, 0, 0, 0, 0, 3, 1, 1, 0, 0, 0],
  [0, 0, 0, 0, 3, 1, 1, 0, 0, 0, 0],
  [0, 0, 0, 3, 1, 1, 0, 0, 0, 0, 0],
  [0, 0, 3, 1, 1, 0, 0, 0, 0, 0, 0],
  [0, 3, 1, 1, 1, 1, 1, 1, 0, 0, 0],
  [0, 0, 3, 1, 1, 1, 1, 0, 0, 0, 0],
  [0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0],
  [0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0],
  [0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const POWERUP_SPRITE_MULTISHOT: PixelGrid = [
  // Triple Shot
  [0, 0, 1, 1, 0, 0, 0, 1, 1, 0, 0],
  [0, 1, 3, 1, 0, 0, 0, 1, 3, 1, 0],
  [0, 1, 1, 1, 0, 0, 0, 1, 1, 1, 0],
  [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0],
  [0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0],
  [0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0],
  [0, 0, 1, 0, 0, 2, 0, 0, 1, 0, 0],
  [0, 1, 2, 1, 2, 2, 2, 1, 2, 1, 0],
  [1, 2, 2, 2, 1, 1, 1, 2, 2, 2, 1],
  [0, 1, 1, 1, 0, 0, 0, 1, 1, 1, 0],
];

export const POWERUP_SPRITE_CRITICAL: PixelGrid = [
  // Target/Crosshair
  [0, 0, 0, 0, 1, 2, 1, 0, 0, 0, 0],
  [0, 0, 0, 0, 1, 2, 1, 0, 0, 0, 0],
  [0, 0, 1, 1, 0, 0, 0, 1, 1, 0, 0],
  [0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0],
  [1, 1, 0, 0, 2, 4, 2, 0, 0, 1, 1],
  [2, 2, 0, 0, 4, 3, 4, 0, 0, 2, 2],
  [1, 1, 0, 0, 2, 4, 2, 0, 0, 1, 1],
  [0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0],
  [0, 0, 1, 1, 0, 0, 0, 1, 1, 0, 0],
  [0, 0, 0, 0, 1, 2, 1, 0, 0, 0, 0],
  [0, 0, 0, 0, 1, 2, 1, 0, 0, 0, 0],
];

export const ALIEN_SPRITE_VOID_WALKER: PixelGrid = [
  // Dark, glitchy bubble
  [0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0],
  [0, 0, 1, 2, 2, 1, 1, 1, 1, 0, 0],
  [0, 1, 2, 1, 1, 1, 1, 1, 1, 1, 0],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1],
  [1, 1, 4, 0, 1, 1, 1, 0, 4, 1, 1],
  [1, 1, 4, 0, 1, 1, 1, 0, 4, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [0, 1, 1, 1, 2, 2, 2, 1, 1, 1, 0],
  [0, 0, 1, 2, 0, 2, 0, 2, 1, 0, 0],
  [0, 0, 0, 1, 0, 1, 0, 1, 0, 0, 0],
];

export const ALIEN_SPRITE_PLASMA_BORN: PixelGrid = [
  // Energy core with electric aura
  [0, 0, 0, 3, 0, 4, 0, 3, 0, 0, 0],
  [0, 0, 3, 1, 1, 4, 1, 1, 3, 0, 0],
  [0, 3, 1, 1, 1, 4, 1, 1, 1, 3, 0],
  [3, 1, 1, 4, 4, 4, 4, 4, 1, 1, 3],
  [0, 1, 1, 4, 4, 4, 4, 4, 1, 1, 0],
  [4, 4, 4, 4, 4, 2, 4, 4, 4, 4, 4],
  [0, 1, 1, 4, 4, 4, 4, 4, 1, 1, 0],
  [3, 1, 1, 4, 4, 4, 4, 4, 1, 1, 3],
  [0, 3, 1, 1, 1, 4, 1, 1, 1, 3, 0],
  [0, 0, 3, 1, 1, 4, 1, 1, 3, 0, 0],
  [0, 0, 0, 3, 0, 4, 0, 3, 0, 0, 0],
];

export const ALIEN_SPRITE_NEBULA_JELLY: PixelGrid = [
  // Soft, glowing bubble
  [0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0],
  [0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0],
  [0, 1, 3, 1, 1, 1, 1, 1, 3, 1, 0],
  [1, 3, 1, 1, 1, 1, 1, 1, 1, 3, 1],
  [1, 3, 1, 4, 4, 1, 4, 4, 1, 3, 1],
  [1, 3, 1, 4, 4, 1, 4, 4, 1, 3, 1],
  [1, 3, 1, 1, 1, 1, 1, 1, 1, 3, 1],
  [0, 1, 3, 1, 2, 2, 2, 1, 3, 1, 0],
  [0, 0, 1, 3, 2, 2, 2, 3, 1, 0, 0],
  [0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export function getSpriteForType(type: string): PixelGrid {
  switch (type) {
    case 'scout':
      return ALIEN_SPRITE_SCOUT;
    case 'tank':
      return ALIEN_SPRITE_TANK;
    case 'healer':
      return ALIEN_SPRITE_HEALER;
    case 'guardian':
      return ALIEN_SPRITE_GUARDIAN;
    case 'hoarder':
      return ALIEN_SPRITE_HOARDER;
    case 'void_walker':
      return ALIEN_SPRITE_VOID_WALKER;
    case 'plasma_born':
      return ALIEN_SPRITE_PLASMA_BORN;
    case 'nebula_jelly':
      return ALIEN_SPRITE_NEBULA_JELLY;
    default:
      return ALIEN_SPRITE_NORMAL;
  }
}

export function getPowerUpSprite(type: string): PixelGrid {
  switch (type) {
    case 'points':
      return POWERUP_SPRITE_POINTS;
    case 'damage':
      return POWERUP_SPRITE_DAMAGE;
    case 'speed':
      return POWERUP_SPRITE_SPEED;
    case 'multishot':
      return POWERUP_SPRITE_MULTISHOT;
    case 'critical':
      return POWERUP_SPRITE_CRITICAL;
    default:
      return POWERUP_SPRITE_POINTS;
  }
}

export const BOSS_SPRITE_COLOSSUS: PixelGrid = [
  // Level 25: Tank-like, heavy
  [0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 2, 1, 1, 1, 1, 1, 1, 2, 0, 0, 0, 0],
  [0, 0, 0, 2, 1, 1, 3, 3, 3, 1, 1, 2, 0, 0, 0, 0],
  [0, 0, 2, 1, 1, 3, 1, 1, 1, 3, 1, 1, 2, 0, 0, 0],
  [0, 2, 1, 1, 1, 1, 1, 4, 1, 1, 1, 1, 1, 2, 0, 0],
  [2, 1, 1, 1, 1, 1, 4, 4, 4, 1, 1, 1, 1, 1, 2, 0],
  [2, 1, 1, 1, 1, 1, 1, 4, 1, 1, 1, 1, 1, 1, 2, 0],
  [2, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1, 4, 1, 1, 2, 0],
  [2, 1, 4, 4, 4, 1, 1, 1, 1, 1, 4, 4, 4, 1, 2, 0],
  [2, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1, 4, 1, 1, 2, 0],
  [2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 0],
  [2, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 2, 0],
  [0, 2, 1, 2, 1, 1, 1, 2, 1, 1, 1, 2, 1, 2, 0, 0],
  [0, 0, 2, 2, 1, 1, 1, 2, 1, 1, 1, 2, 2, 0, 0, 0],
  [0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const BOSS_SPRITE_SWARM_QUEEN: PixelGrid = [
  // Level 50: Insectoid
  [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 1, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 1, 0, 0],
  [0, 0, 1, 1, 0, 1, 1, 3, 3, 1, 1, 0, 1, 1, 0, 0],
  [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0],
  [0, 0, 0, 0, 1, 1, 4, 1, 1, 4, 1, 1, 0, 0, 0, 0],
  [0, 0, 0, 1, 1, 4, 4, 1, 1, 4, 4, 1, 1, 0, 0, 0],
  [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
  [0, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 0],
  [1, 1, 0, 2, 0, 1, 1, 2, 2, 1, 1, 0, 2, 0, 1, 1],
  [1, 0, 0, 0, 0, 1, 2, 1, 1, 2, 1, 0, 0, 0, 0, 1],
  [0, 0, 0, 0, 0, 1, 2, 1, 1, 2, 1, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 1, 2, 2, 1, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
];

export const BOSS_SPRITE_VOID_CONSTRUCT: PixelGrid = [
  // Level 75: Geometric/Dark
  [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 1, 3, 3, 1, 1, 3, 3, 1, 0, 0, 0, 0],
  [0, 0, 0, 1, 3, 1, 1, 1, 1, 1, 1, 3, 1, 0, 0, 0],
  [0, 0, 1, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 1, 0, 0],
  [0, 1, 1, 1, 0, 0, 4, 1, 1, 4, 0, 0, 1, 1, 1, 0],
  [1, 1, 1, 0, 0, 4, 4, 1, 1, 4, 4, 0, 0, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 4, 4, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1],
  [0, 1, 1, 1, 0, 0, 1, 2, 2, 1, 0, 0, 1, 1, 1, 0],
  [0, 0, 1, 1, 1, 0, 0, 2, 2, 0, 0, 1, 1, 1, 0, 0],
  [0, 0, 0, 1, 2, 1, 1, 2, 2, 1, 1, 2, 1, 0, 0, 0],
  [0, 0, 0, 0, 1, 2, 2, 2, 2, 2, 2, 1, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 1, 1, 2, 2, 1, 1, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
];

export const BOSS_SPRITE_OMEGA_CORE: PixelGrid = [
  // Level 100: Chaotic Energy
  [0, 0, 0, 0, 0, 2, 1, 4, 4, 1, 2, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 2, 1, 4, 3, 3, 4, 1, 2, 0, 0, 0, 0],
  [0, 0, 0, 2, 1, 4, 3, 1, 1, 3, 4, 1, 2, 0, 0, 0],
  [0, 0, 2, 1, 4, 1, 1, 1, 1, 1, 1, 4, 1, 2, 0, 0],
  [0, 2, 1, 4, 1, 1, 1, 4, 4, 1, 1, 1, 4, 1, 2, 0],
  [2, 1, 4, 1, 1, 1, 4, 3, 3, 4, 1, 1, 1, 4, 1, 2],
  [1, 4, 3, 1, 1, 4, 3, 1, 1, 3, 4, 1, 1, 3, 4, 1],
  [4, 3, 1, 1, 4, 3, 1, 1, 1, 1, 3, 4, 1, 1, 3, 4],
  [4, 3, 1, 1, 4, 3, 1, 1, 1, 1, 3, 4, 1, 1, 3, 4],
  [1, 4, 3, 1, 1, 4, 3, 1, 1, 3, 4, 1, 1, 3, 4, 1],
  [2, 1, 4, 1, 1, 1, 4, 3, 3, 4, 1, 1, 1, 4, 1, 2],
  [0, 2, 1, 4, 1, 1, 1, 4, 4, 1, 1, 1, 4, 1, 2, 0],
  [0, 0, 2, 1, 4, 1, 1, 1, 1, 1, 1, 4, 1, 2, 0, 0],
  [0, 0, 0, 2, 1, 4, 3, 1, 1, 3, 4, 1, 2, 0, 0, 0],
  [0, 0, 0, 0, 2, 1, 4, 3, 3, 4, 1, 2, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 2, 1, 4, 4, 1, 2, 0, 0, 0, 0, 0],
];

export const BOSS_SPRITE_TINY_TYRANT: PixelGrid = [
  // Level 5: Tutorial Boss - Cute alien baby with antennae
  [0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0], // Antennae tips
  [0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0],
  [0, 0, 0, 0, 2, 3, 0, 0, 0, 0, 3, 2, 0, 0, 0, 0], // Antennae stems
  [0, 0, 0, 0, 2, 1, 3, 3, 3, 3, 1, 2, 0, 0, 0, 0],
  [0, 0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 3, 0, 0, 0], // Head top
  [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 0, 0],
  [0, 3, 1, 1, 4, 4, 3, 1, 1, 3, 4, 4, 1, 1, 3, 0], // Big eyes
  [0, 3, 1, 4, 4, 0, 4, 1, 1, 4, 0, 4, 4, 1, 3, 0], // Eye pupils
  [3, 1, 1, 4, 3, 3, 4, 1, 1, 4, 3, 3, 4, 1, 1, 3], // Eye shine
  [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3],
  [3, 1, 1, 1, 1, 1, 2, 2, 2, 2, 1, 1, 1, 1, 1, 3], // Smile
  [0, 3, 1, 1, 1, 2, 3, 1, 1, 3, 2, 1, 1, 1, 3, 0], // Happy mouth
  [0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 0],
  [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 0, 0],
  [0, 0, 0, 3, 3, 1, 1, 1, 1, 1, 1, 3, 3, 0, 0, 0], // Bottom
  [0, 0, 0, 0, 0, 3, 3, 3, 3, 3, 3, 0, 0, 0, 0, 0],
];

